// extracted by mini-css-extract-plugin
module.exports = {"wordFlip":"WordsFlip_wordFlip__I_aAS"};